import { action, makeAutoObservable, observable } from "mobx";
import { ACLRequest } from "../requests/ACLRequest";
import authenticationStore from "./authenticationStore";

class ACLStore {
    // Page list salary
     aclActionList = [];
     aclActionUpdateList = [];
    
     aclGroupList = [];
    constructor() {
        makeAutoObservable(this);
    }

     getACLActionList = () => {
        return new Promise((resolve, reject) => {
            ACLRequest.getACLActionList()
                .then((response) => {
                    this.aclActionList = response.data || [];
                    this.aclActionUpdateList = response.data || [];
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

     clearActionList = () => {
        this.aclActionList.length = 0;
        this.aclActionUpdateList.length = 0;
    };
     clearAclGroupList = () => {
        this.aclGroupList.length = 0;
    };

     getACLDetail = (code) => {
        return new Promise((resolve, reject) => {
            ACLRequest.getACLDetail(code)
                .then((response) => {
                    this.aclActionList = response.data.actions || [];
                    this.aclActionUpdateList = response.data.actions || [];
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

     setAclActionUpdateList = (payload) => {
        this.aclActionUpdateList = payload;
    };

     getACLGroupList = () => {
        return new Promise((resolve, reject) => {
            ACLRequest.getACLGroupList()
                .then((response) => {
                    this.aclGroupList = response.data || [];
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

     updateACLGroup = (code, payload) => {
        return new Promise((resolve, reject) => {
            ACLRequest.updateACLGroup(code, payload)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };
     assignACLGroup = (payload) => {
        return new Promise((resolve, reject) => {
            ACLRequest.assignACLGroup(payload)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

     createACLGroup = (payload) => {
        return new Promise((resolve, reject) => {
            ACLRequest.createACLGroup(payload)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };
     deleteACLGroup = (payload) => {
        return new Promise((resolve, reject) => {
            ACLRequest.deleteACLGroup(payload)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

     cloneACLGroup = (code) => {
        return new Promise((resolve, reject) => {
            ACLRequest.cloneACLGroup(code)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

     aclAclGroupName = "";
     aclActionsByUser = [];

     getACLDetailByUser = (userName) => {
        return new Promise((resolve, reject) => {
            ACLRequest.getACLDetailByUser(userName)
                .then((response) => {
                    // console.log(response)
                    this.aclAclGroupName = response.data.name;
                    this.aclActionsByUser = response.data.actions || [];
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };
     checkAccessControlAction = (aclActionType) => {
        const actionType = this.aclActionsByUser.find(
            (item) => item.code === aclActionType
        );
        return (
            !!actionType?.status ||
            authenticationStore.isAccountAdmin ||
            authenticationStore.isSuperAdmin
        );
    };
}

export default new ACLStore();
